import { render, staticRenderFns } from "./goodsType.vue?vue&type=template&id=111e7dd6&scoped=true&"
import script from "./goodsType.vue?vue&type=script&lang=js&"
export * from "./goodsType.vue?vue&type=script&lang=js&"
import style0 from "./goodsType.vue?vue&type=style&index=0&id=111e7dd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111e7dd6",
  null
  
)

export default component.exports